import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import { isLoading, isLogin, myRoles } from '../../Redux/user-profile/selectors';
import { toggleSideMenu } from '../../Redux/side-menu/actions';

import Menu from './Menu';

const filterMenu = (menus = [], isLogin = false, myRoles = []) =>
  menus.filter(
    menu =>
      menu.private !== true ||
      (isLogin &&
        menu.roles &&
        (menu.roles.length === 0 ||
          (menu.roles.length > 0 && menu.roles.some(role => myRoles.indexOf(role) >= 0))))
  );

const MapperHOC = compose(
  withRouter,
  connect(
    state => ({
      isLoading: isLoading(state),
      isLogin: isLogin(state),
      myRoles: myRoles(state),
    }),
    { toggleSideMenu }
  ),
  withProps(({ menus, isLogin, myRoles }) => ({
    rendermenus: filterMenu(menus, isLogin, myRoles) || [],
  }))
  // onlyUpdateForKeys(['menus', 'logoUrl']),
);

export default MapperHOC(Menu);
